import { FC } from 'react';
import { SummaryStatCard } from 'components/summary-stat-card/summary-stat-card';
import { formatNumber } from 'utils/number';
import type { DiscountRateScenarioAggregations } from './types';
import styles from './summary-cards.module.scss';

export type SummaryCardType = 'last24h' | 'last7d' | 'lastMonth';

interface DiscountRateSummaryCardsProps {
  aggregations: DiscountRateScenarioAggregations | undefined;
  onCardClick?: (card: SummaryCardType) => void;
}

/**
 * Summary KPI tiles for the DRS list page.
 * @param {DiscountRateSummaryCardsProps} props - The component props
 * @return {JSX.Element} The summary cards grid
 */
const DiscountRateSummaryCards: FC<DiscountRateSummaryCardsProps> = ({
  aggregations,
  onCardClick,
}) => {
  return (
    <div className={styles.cardsContainer}>
      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Total Scenarios"
          value={formatNumber(
            aggregations?.totalCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last 24 Hours"
          value={
            aggregations?.createdLast24h !== undefined
              ? `+${formatNumber(
                  aggregations.createdLast24h,
                  0,
                  0,
                  'decimal',
                  true,
                  '--'
                )}`
              : '--'
          }
          valueColor="green"
          tooltipText="Scenarios created in the 24 hours preceding now"
          onFilterClick={onCardClick ? () => onCardClick('last24h') : undefined}
          filterTooltip="Filter by Created in Last 24 Hours"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last 7 Days"
          value={
            aggregations?.createdLast7d !== undefined
              ? `+${formatNumber(
                  aggregations.createdLast7d,
                  0,
                  0,
                  'decimal',
                  true,
                  '--'
                )}`
              : '--'
          }
          valueColor="green"
          tooltipText="Scenarios created in the 7 days preceding now"
          onFilterClick={onCardClick ? () => onCardClick('last7d') : undefined}
          filterTooltip="Filter by Created in Last 7 Days"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Created in Last Month"
          value={
            aggregations?.createdLastMonth !== undefined
              ? `+${formatNumber(
                  aggregations.createdLastMonth,
                  0,
                  0,
                  'decimal',
                  true,
                  '--'
                )}`
              : '--'
          }
          valueColor="green"
          tooltipText="Scenarios created in the 30 days preceding now"
          onFilterClick={
            onCardClick ? () => onCardClick('lastMonth') : undefined
          }
          filterTooltip="Filter by Created in Last Month"
        />
      </div>
    </div>
  );
};

export { DiscountRateSummaryCards };
